/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 5/4/20
 * Time: 5:02 PM
 */
export const SUCCESS_MESSAGE = "SUCCESS_INQUIRY_MESSAGE";
export const FAILED_MESSAGE = "FAILED_INQUIRY_MESSAGE";
export const RESET_WARNING = 'RESET_WARNING';
